export const completeRegistration = state => {
  return state.phone.trim().length !== 0
};
